import styled from 'styled-components';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import AttributesSection from '../../../common/rfq/AttributesSection';

export const ContentStyled = styled.div`
  min-height: 20rem;
  position: relative;
  margin: 8rem auto 6.4rem;
`;

export const AttributesProgressStatusStyled = styled.h3`
  font-size: 1.8rem;
  line-height: 2.8rem;
  text-align: center;
  margin: 1rem auto 5rem;
  font-weight: 400;
  color: ${colors.neutral[900]};
`;

export const AddAttributeButtonStyled = styled(Button)`
  margin: 0 auto 6rem;
`;

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  gap: 1.6rem;
  margin-bottom: 9.6rem;
`;

export const NoDataMessageStyled = styled.p`
  margin: 0 0 3rem;
  font-size: 1.8rem;
  line-height: 2.8rem;
  color: ${colors.neutral[900]};
  text-align: center;
`;

export const CustomAttributesSectionStyled = styled(AttributesSection)`
  gap: 5rem;
  padding-bottom: 4rem;
`;

export const RemoveAttributeLabelStyled = styled.b`
  color: ${colors.neutral[900]};
  margin: 0 0.5rem;
`;
